import React from "react";
import { TextField, Typography, Box } from "@mui/material";

interface AboutStepProps {
    title: string;
    about: string;
    onTitleChange: (value: string) => void;
    onAboutChange: (value: string) => void;
}

const MAX_ABOUT_LENGTH = 500;

const AboutStep: React.FC<AboutStepProps> = ({ title, about, onTitleChange, onAboutChange }) => {
    const handleAboutChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // Enforce max length client-side as well
        if (event.target.value.length <= MAX_ABOUT_LENGTH) {
            onAboutChange(event.target.value);
        }
    };

    const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onTitleChange(event.target.value);
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom align="center">
                Tell us about yourself
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom align="center">
                Add your professional title and a brief introduction.
            </Typography>

            <TextField
                label="Professional Title"
                fullWidth
                variant="outlined"
                value={title}
                onChange={handleTitleChange}
                placeholder="e.g., Software Engineer, Product Manager, Student"
                sx={{ mt: 3, mb: 2 }}
                helperText={"This will be your headline across the platform."}
            />

            <TextField
                label="About Section"
                multiline
                rows={6}
                fullWidth
                variant="outlined"
                value={about}
                onChange={handleAboutChange}
                inputProps={{
                    maxLength: MAX_ABOUT_LENGTH, // Enforce max length in the input element
                }}
                helperText={`${about.length}/${MAX_ABOUT_LENGTH} characters`}
                placeholder="Share a bit about your professional journey, skills, and aspirations."
            />
        </Box>
    );
};

export default AboutStep;
